<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <div>
    <div class="row">
      <div class="col-12">
        <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
          <li class="nav-item col-6 px-0">
            <router-link
              to="/sertifikasi/jadwal-tc/sesi-1"
              class="nav-link p-3 px-5 font-weight-bold text-white border-0"
              style="display: flex; justify-content: center; align-items: center;"
              id="home-tab"
              data-toggle="tab"
              href="#home"
              role="tab"
              aria-controls="home"
              aria-selected="true"
            >Sertifikasi</router-link>
          </li>
          <li class="nav-item col-6 px-0">
            <router-link
              to="/sertifikasi/jadwal-tc/rpl-sesi-satu"
              class="nav-link p-3 px-5 font-weight-bold text-white"
              style="background-color: #486ba7; display: flex; justify-content: center; align-items: center;"
              id="profile-tab"
              data-toggle="tab"
              href="#profile"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
            >RPL</router-link>
          </li>
        </ul>
      </div>
    </div>
    <CCard>
      <!-- Tabs -->
      <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
        <li class="nav-item">
          <router-link
            to="/sertifikasi/jadwal-tc/rpl-sesi-satu"
            class="nav-link p-3 px-5 font-weight-bold text-white"
            id="home-tab"
            data-toggle="tab"
            href="#home"
            role="tab"
            aria-controls="home"
            aria-selected="true"
          >Sesi 1</router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/sertifikasi/jadwal-tc/rpl-sesi-dua"
            class="nav-link p-3 px-5 font-weight-bold text-white border-0"
            style="background-color: #486ba7;"
            id="profile-tab"
            data-toggle="tab"
            href="#profile"
            role="tab"
            aria-controls="profile"
            aria-selected="false"
          >Sesi 2</router-link>
        </li>
        <li class="nav-item">
          <router-link
            to="/sertifikasi/jadwal-tc/rpl-sesi-tiga"
            class="nav-link p-3 px-5 font-weight-bold text-white"
            id="contact-tab"
            data-toggle="tab"
            href="#contact"
            role="tab"
            aria-controls="contact"
            aria-selected="false"
          >Sesi 3</router-link>
        </li>
      </ul>

      <CCardBody>
        <CRow>
          <div class="col-sm-12 col-xl-2">
            <div class="form-group">
              <label for>Data Perhalaman</label>
              <select class="form-control" name id>
                <option>10</option>
                <option>25</option>
                <option>100</option>
                <option>Semua Data</option>
              </select>
            </div>
          </div>
          <div class="col-sm-12 col-xl-3">
            <div class="form-group">
              <label for>Pencarian</label>
              <input type="text" name id class="form-control" placeholder="Cari Data ..." />
            </div>
          </div>
          <div class="col-lg-7 col-sm-12 d-flex align-items-center">
            <!-- <CButton color="info" style="float:right;margin-right:10px" class="btn-md ml-auto">Print</CButton> -->
            <CButton color="danger" style="float:right;margin-right:10px" class="btn-md ml-auto">Export PDF</CButton>
            <CDropdown
              toggler-text="Ekspor Excel"
              color="warning"
              class="mr-2 d-inline-block text-white float-right"
            >
              <CDropdownItem>Export All</CDropdownItem>
              <CDropdownItem>Export Page</CDropdownItem>
            </CDropdown>
            <router-link to="/sertifikasi/jadwal-tc/upload-absensi-rpl">
              <CButton
                color="warning"
                style="float:right;margin-right:10px"
                class="btn-md btn-upload text-white"
              >UPLOAD ABSENSI</CButton>
            </router-link>
          </div>
        </CRow>
        <CRow>
          <CCol lg="12" class="table-responsive">
            <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
              <template #no="{item}">
                <td class="py-2">{{ item.no }}</td>
              </template>
              <template #pers_dokumen="{item}">
                <td class="py-2">
                  <button class="btn btn-sm btn-success" v-if="item.pers_dokumen == 1">Terverifikasi</button>
                  <button class="btn btn-sm btn-danger" v-else>Belum Terverifikasi</button>
                </td>
              </template>
              <template #aksi>
                <td class="py-2 d-flex align-items-center">
                  <CButton
                    color="warning"
                    class="btn-sm text-white"
                    square
                    @click="modalEmail = true"
                  >
                    <font-awesome-icon icon="envelope" @click="modalEmail = true" />
                  </CButton>&nbsp;&nbsp;
                  <CButton color="success" class="btn-sm mx-1" square @click="modalVerif = true">
                    <i class="fa fa-file" aria-hidden="true"></i>
                  </CButton>&nbsp;&nbsp;
                  <CButton color="info" class="btn-sm" square @click="myModal = true">
                    <font-awesome-icon icon="edit" />
                  </CButton>&nbsp;&nbsp;
                </td>
              </template>
            </CDataTable>
            <CPagination
              style="float:right"
              :active-page.sync="currentPage"
              :pages="10"
              responsive
            />
          </CCol>
        </CRow>
        <!-- Modal Tambah -->
        <CModal
          title="Modal title"
          :show.sync="myModal"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm>
            <CRow>
              <div class="modal-body">
                <form>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="name font-weight-bold" class="font-weight-bold">Nama</label>
                      <input type="text" class="form-control" id="name" disabled />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="sesi1" class="font-weight-bold">Kehadiran</label>
                      <select class="form-control" name id>
                        <option>Pilih Kehadiran</option>
                        <option></option>
                        <option></option>
                      </select>
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="sertifikasi" class="font-weight-bold">Sertifikasi</label>
                      <input type="text" class="form-control" id="sertifikasi" disabled />
                    </div>
                  </div>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for class="font-weight-bold">Mata Uji</label>
                      <br />
                      <ol class="ol-custom pl-3">
                        <li class="li-custom">APK</li>
                        <li class="li-custom">AAS</li>
                      </ol>
                    </div>
                  </div>
                </form>
              </div>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h4 font-weight-bold">Edit</h6>            
          </template>
          <template #footer>
            <CButton @click="myModal = false" color="danger">Tutup</CButton>
            <CButton type="submit" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->
        <!-- Modal Email -->
        <CModal
          title="Modal title"
          :show.sync="modalEmail"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm>
            <CRow>
              <CCol sm="12">
                <CInput class="font-weight-bold" label="Subjek" placeholder="Masukkan Subjek" />
              </CCol>
              <CCol sm="12">
                <CTextarea
                  class="font-weight-bold"
                  label="Pesan"
                  rows="3"
                  placeholder="Masukkan isi pesan"
                />
              </CCol>

              <CCol sm="12 mb-5">
                <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
                <br />
                <div class="custom-file text-truncate">
                  <div class="custom-file text-truncate">
                    <input
                      type="file"
                      class="custom-file-input"
                      id="customFileLangHTML"
                      placeholder="Plih File"
                    />
                    <label
                      class="custom-file-label"
                      for="customFileLangHTML"
                      data-browse="Unggah"
                    >{{ fileName }}</label>
                  </div>
                </div>
              </CCol>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>            
          </template>
          <template #footer class="mt-5">
            <CButton @click="modalEmail = false" color="danger">Tutup</CButton>
            <CButton type="submit" color="success">Kirim</CButton>
          </template>
        </CModal>
        <!-- End Modal -->
        <!-- Modal Verif -->
        <CModal
          title="Modal title"
          :show.sync="modalVerif"
          :no-close-on-backdrop="true"
          :centered="true"
        >
          <CForm>
            <CRow>
              <div class="modal-body">
                <form>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="nama" class="font-weight-bold">Foto Terbaru</label>
                      <div class="text-center d-block">
                        <img src="/img/ic_pdf.png" width="100px" alt="icon" srcset />
                        <br />
                        <a href target="_blank" class="text-success">Lihat FIle</a>
                      </div>
                    </div>
                  </div>
                  <CCol sm="12 mb-4 mt-3">
                    <label for class="font-weight-bold">Status</label>
                    <br />
                    <div class="d-flex align-items-center">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="aktif"
                          value="1"
                        />
                        <label class="custom-control-label" for="aktif">Terverifikasi</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="tidak_aktif"
                          value="0"
                        />
                        <label class="custom-control-label" for="tidak_aktif">Belum Terverifikasi</label>
                      </div>
                    </div>
                  </CCol>
                  <div class="form-row">
                    <div class="form-group col-md-12">
                      <label for="nama" class="font-weight-bold">KTP</label>
                      <div class="justify-content-center text-center">
                        <img src="/img/ic_pdf.png" width="100px" alt="icon" srcset />
                        <br />
                        <a href target="_blank" class="text-success">Lihat FIle</a>
                      </div>
                    </div>
                  </div>
                  <CCol sm="12 mb-4 mt-3">
                    <label for class="font-weight-bold">Status</label>
                    <br />
                    <div class="d-flex align-items-center">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="aktif"
                          value="1"
                        />
                        <label class="custom-control-label" for="aktif">Terverifikasi</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="tidak_aktif"
                          value="0"
                        />
                        <label class="custom-control-label" for="tidak_aktif">Belum Terverifikasi</label>
                      </div>
                    </div>
                  </CCol>
                </form>
              </div>
            </CRow>
          </CForm>
          <template #header>
            <h6 class="modal-title h4 font-weight-bold">Verifikasi</h6>            
          </template>
          <template #footer>
            <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
            <CButton type="submit" color="success">Simpan</CButton>
          </template>
        </CModal>
        <!-- End Modal -->
      </CCardBody>
      <!-- End Data sesi 3 -->
    </CCard>
  </div>
</template>
<script>
const items = [
  {
    no: 1,
    no_anggota: "AGT-1",
    nama: "Ilham Majid Rabbani",
    level: "Dasar",
    pers_dokumen: 1,
    kehadiran: "YA",
    no_telp: "08737423847634",
    rpl: "J-CPA",
    mata_uji: "APK AAS"
  },
  {
    no: "2",
    no_anggota: "AGT-1",
    nama: "Ilham Majid Rabbani",
    level: "Dasar",
    pers_dokumen: 0,
    kehadiran: "YA",
    no_telp: "08737423847634",
    rpl: "J-CPA",
    mata_uji: "APK AAS"
  },
  {
    no: "3",
    no_anggota: "AGT-1",
    nama: "Ilham Majid Rabbani",
    level: "Dasar",
    pers_dokumen: 1,
    kehadiran: "YA",
    no_telp: "08737423847634",
    rpl: "J-CPA",
    mata_uji: "APK AAS"
  },
  {
    no: "4",
    no_anggota: "AGT-1",
    nama: "Ilham Majid Rabbani",
    level: "Profesional",
    pers_dokumen: 1,
    kehadiran: "YA",
    no_telp: "08737423847634",
    rpl: "J-CPA",
    mata_uji: "APK AAS"
  },
  {
    no: "5",
    no_anggota: "AGT-1",
    nama: "Ilham Majid Rabbani",
    level: "Profesional",
    pers_dokumen: 0,
    kehadiran: "YA",
    no_telp: "08737423847634",
    rpl: "J-CPA",
    mata_uji: "APK AAS"
  }
];

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "no_anggota",
    label: "No.Anggota",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "nama",
    label: "Nama",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "level",
    label: "Level",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "no_telp",
    label: "No. Telepon",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "kehadiran",
    label: "Kehadiran",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "rpl",
    label: "RPL",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "mata_uji",
    label: "Mata Uji",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "pers_dokumen",
    label: "Persyaratan Dokumen",
    sorter: true,
    filter: false,
    _style: "vertical-align: middle;"
  },
  {
    key: "aksi",
    _style: "width:10%; vertical-align: middle;",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Master RPL",
  data() {
    return {
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      formData: {
        judul: "",
        file: ""
      },
      formData: {
        deskripsi: "",
        file: ""
      },
      fileName: "Choose File...",
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      modalEmail: false,
      modalVerif: false,
      horizontal: { label: "col-3", input: "col-9" },

      collapseDuration: 0,
      content: []
    };
  },
  methods: {}
};
</script>